<div class="container-fluid background-transparent pt-0">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
</div>

<div class="content-inner background-section">
  <div class="title-bar background-transparent" *ngIf=isDesktop>
    <a class="back-button mt-2 mb-4" (click)="emitData({key:'back'})"><img class="svg mr-2 ml-4 back-button"
        src="assets/ph-bhp-layout/svg/back.svg" /> {{ translationKeys.SOPObservation.Back | translate}}</a>
    <div class="container-fluid d-md-flex justify-content-between background-transparent">
      <h2 class="page-title">{{ 'EVALUATION.OVERVIEW_INDIVIDUAL_DATA_1' | translate }}</h2>
      <div>
        <lib-php-bhp-chart-export [gridData]="gridData" [sopId]="sopiDs" [sopDetail]="sopDetail" [filter]="filter"
          [fields]="fields" (childData)="emitData($event)" [select]="'individualData'" [fileName]="pageTitle"
          [appName]="appName" [clickExcelBtn]="clickExcelBtn" [userData]="userData"
          (resetClickBtn)="resetExportAs($event)" class="col p-0"></lib-php-bhp-chart-export>
      </div>
    </div>
  </div>
  <div>
    <div class="evaluation-section container-fluid reportFiter">
      <div class="row">
        <div class="col my-3 d-flex  justify-content-end">
          <button class="btn-link-reset" (click)="resetFilters()" *ngIf="userHasFilter">{{ 'EVALUATION.RESET_FILTERS' | translate }}</button>
          <button class="btn-cancel-bordered-bd" (click)="openFilter()" *ngIf="!userHasFilter">{{ 'EVALUATION.ADD_FILTER' | translate }}</button>
        </div>
      </div>

      <div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="form-group multiselect-container">
              <div class="multiselect-top d-flex justify-content-between">
                <label>{{ "EVALUATION.SOP" | translate }}</label>
                <button class="multiselect-clear" (click)="resetSOPFilter(true)">
                  <img src="assets/icons/closeOutlined.svg" />
                </button>
              </div>
              <div class="multiselect-div">
                <kendo-multiselect #multiselect [data]="sopDetail" [(ngModel)]="sopiDs" [textField]="'title'" (valueChange)="onMultiselectChange($event)"
                  [valueField]="'sopid'" [autoClose]="false" placeholder="{{ 'EVALUATION.All.SOPS' | translate }}">
                  <ng-template kendoMultiSelectTagTemplate let-dataItem>
                    {{ getSOPTranslation(dataItem.title) | labelSanitizer}}
                  </ng-template>
                  <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    <input type="checkbox" class="k-checkbox">
                     <div>
                      <span>{{ getSOPTranslation(dataItem.title) | labelSanitizer }}</span>
                      <br />
                      <small class="text-muted institution-names">
                        {{ service.getInstitutionNames(dataItem, roleId) | labelSanitizer }}
                      </small>
                     </div>
                  </ng-template>
                </kendo-multiselect>
              </div>
            </div>
          </div>
        </div>

      </div>
      <lib-ph-bhp-filter #filter [userData]="userData" [isDesktop]='isDesktop' [evaluationLoaded]="evaluationLoaded"
        [userHasFilter]="userHasFilter" (filterSaved)="onFilterSaved()" [filterIndex]="0" [isMultiselectReport]="false"></lib-ph-bhp-filter>

      <div class="row justify-content-between">
        <div class="col my-3 d-flex justify-content-start" (click)="showDeleteSelectionModal()">
          <div>
            <img class="dropdown-arrow mr-2" src="assets/icons/trashDarkOutlined.svg" />
            <label class="selection-label">{{ 'EVALUATION.DELETE_SELECTION' | translate }}</label>
          </div>
        </div>

        <div class="col my-3 justify-content-end d-flex">
          <div class="dropdown dropdown-bhp">
            <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
              <div class="d-flex align-items-center">
                <img class="dropdown-arrow mr-2" src="assets/icons/downloadDarkOutlined.svg" />
                <label>{{ 'EVALUATION.EXPORT' | translate }}</label>
              </div>
              <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
            </div>

            <ul class="dropdown-menu">
              <li class="dropdown-item" *ngIf="gridData" (click)="excelDownload()">{{ 'GENERAL.EXCEL' |
                translate }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-12 static-card first-card last-card">
        <div class="row" *ngIf="userHasFilter">
          <h1 class="section-title col-md-6">{{ 'EVALUATION.OVERVIEW_INDIVIDUAL_DATA_1' | translate }}</h1>
        </div>
        <bd-light-table #gridTable [gridData]="gridData || []" [pageInfo]="pageInfo" [fields]="fields"
          *ngIf="userHasFilter" [actions]="actionItems" [isSelectable]="isSelectable"
          [isEvaluationTable]="isEvaluationTable"></bd-light-table>
        <div class="no-data-box" *ngIf="!userHasFilter">
          <span class="no-data-text">{{ 'CONFIGURE.FILTERS.NO_FILTER_FOUND' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #delmodal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg">
    </a>
  </div>
  <div class="modal-body">
    <p> {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }} </p>
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{
        'INSTITUTION_MANAGEMENT.NO' | translate }}</button>
      <button (click)="delete();modalRef.hide()" class="btn-bd-empty">{{ 'INSTITUTION_MANAGEMENT.YES' | translate
        }}</button>
    </div>
  </div>
</ng-template>

<ng-template #deleteSelectionModal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg">
    </a>
  </div>
  <div class="modal-body">
    <p> {{ deleteSelectionText }} </p>
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'INSTITUTION_MANAGEMENT.NO'
        | translate }}</button>
      <button (click)="deleteSelection();modalRef.hide()" class="btn-bd-empty">{{ 'INSTITUTION_MANAGEMENT.YES' |
        translate
        }}</button>
    </div>
  </div>
</ng-template>

<ng-template #downloadSOPModal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ 'EVALUATION.DOWNLOAD_SOP_OBSERVATION' | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg">
    </a>
  </div>
  <div class="modal-body">
    <p>{{ 'EVALUATION.FORMAT' | translate }}</p>
    <div class="d-flex align-items-center mb-2">
      <input type="radio" id="pdfOption" name="format" value="pdf" [(ngModel)]="selectedFormat" class="mr-2">
      <label for="pdfOption" class="d-flex align-items-center cursor-pointer">
        <img class="pdf-icon mr-2" src="assets/ph-bhp-evaluation/PDF_file_icon.png"> PDF
      </label>
    </div>
    <div class="d-flex align-items-center">
      <input type="radio" id="imageOption" name="format" value="image" [(ngModel)]="selectedFormat" class="mr-2">
      <label for="imageOption" class="d-flex align-items-center cursor-pointer">
        <mat-icon outline class="icon-size mr-2">image</mat-icon> {{ 'EVALUATION.IMAGE' | translate }}
      </label>
    </div>
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate
        }}</button>
      <button (click)="modalRef.hide();downloadSOP();" class="btn-bd-empty">{{ 'EVALUATION.DOWNLOAD' | translate
        }}</button>
    </div>
  </div>
</ng-template>
